import React from "react";

const NumberInput = React.forwardRef(({ placeholder, tabIndex, className, ...props }, ref) => {
    const isReadOnly = props.readOnly || false;

    const styles = isReadOnly ? { ...props.style, pointerEvents: 'none' } : {};

    return (
        <input
            {...props}
            className={`form-control ${className || ''}`}
            type="number"
            placeholder={placeholder}
            tabIndex={isReadOnly ? -1 : tabIndex}
            ref={ref}
            onKeyDown={(e) => {
                if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                    e.preventDefault();
                }
            }}
            onPaste={(e) => {
                const pastedData = e.clipboardData.getData('Text');
                if (!/^[0-9]+$/.test(pastedData)) {
                    e.preventDefault();
                }
            }}
            onBlur={(e) => {
                if (e.target.value === '') {
                    e.target.value = 0;
                }
            }}
            onFocus={(e) => {
                e.target.value = '';
            }}
            style={styles}
        />
    )
});

export default NumberInput;